"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinsAiButton;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uxUtils = require("@site/ux-utils");
var _button = _interopRequireDefault(require("@ux/button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _wand = _interopRequireDefault(require("@ux/icon/wand"));
var _reactMintl = require("@godaddy/react-mintl");
function SpinsAiButton({
  ctaIconSize = 24,
  onClick = () => {},
  disabled = false,
  spinsAiButtonClassName,
  spinsAiButtonIconColor
}) {
  const {
    isDesktop
  } = (0, _uxUtils.useDeviceType)();
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const handleClick = e => {
    e.stopPropagation();
    onClick();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-inline-flex align-items-center justify-content-center px-0 min-h-8 spin-buy-button ', {
      'mr-2': !isDesktop
    })
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-cy": "spins-ai-button",
    "data-testid": "spins-ai-button",
    className: (0, _classnames.default)('btn-filled ux-button-small spin-buy-button mr-0', {
      [spinsAiButtonClassName]: spinsAiButtonClassName,
      'spin-ai-button': spinsAiButtonClassName,
      'spin-default-buy-button': !spinsAiButtonClassName
    }),
    "aria-label": formatMessage({
      id: 'ai.tryDomainSearchResults'
    }),
    disabled: disabled,
    icon: /*#__PURE__*/_react.default.createElement("div", {
      "data-cy": "spins-ai-icon-uxcore",
      "data-testid": "spins-ai-icon-uxcore",
      className: "d-inline-flex",
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement(_wand.default, {
      fill: spinsAiButtonIconColor || 'black',
      width: ctaIconSize,
      height: ctaIconSize
    })),
    onClick: handleClick
  }));
}
SpinsAiButton.propTypes = {
  ctaIconSize: _propTypes.default.number,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  spinsAiButtonClassName: _propTypes.default.string,
  spinsAiButtonIconColor: _propTypes.default.string
};